module.exports = __webpack_public_path__ + "fonts/fa-light-300.6265ad1.woff2";